import { BaseService } from 'core/services';
import TemplateRouteService from './TemplateRouteService';

class TemplateService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new TemplateRouteService());
    }
}

export default TemplateService;